import querystring from "query-string";
import axiosInstance, { errorHandler } from "./api";
import { UserSortAdapter } from "./utils";

const URL = "/api/role-permission";

const createPermission = axios => permissionName =>
  axios
    .post(
      `${URL}/permission/create`,
      querystring.stringify({
        permissionName,
      }),
    )
    .then(({ data }) => data)
    .catch(errorHandler);

const removePermission = axios => permissionId =>
  axios
    .post(
      `${URL}/permission/delete`,
      querystring.stringify({
        permissionId,
      }),
    )
    .then(({ data }) => data)
    .catch(errorHandler);

const getPermissions = axios => (page, size, filter = "", sort = "") =>
  axios
    .get(
      `${URL}/permissions?${querystring.stringify({
        page,
        size,
        filter,
        sort: UserSortAdapter(sort),
      })}`,
    )
    .then(({ data }) => ({
      data: data.data.content,
      total: data.data.totalElements,
    }))
    .catch(errorHandler);

const createRole = axios => roleName =>
  axios
    .post(`${URL}/role/create`, {}, { params: { roleName } })
    .then(({ data }) => data)
    .catch(errorHandler);

const removeRole = axios => roleId =>
  axios
    .post(`${URL}/role/delete`, {}, { params: { roleId } })
    .then(({ data }) => data)
    .catch(errorHandler);

const getRoles = axios => (page, size, filter = "", sort = "") =>
  axios
    .get(
      `${URL}/roles?${querystring.stringify({
        page,
        size,
        filter,
        sort: UserSortAdapter(sort),
      })}`,
    )
    .then(({ data }) => ({
      data: data.data.content,
      total: data.data.totalElements,
    }))
    .catch(errorHandler);

const getAllRoles = axios => () => getRoles(axios)(0, 2000);

const getAuthorities = axios => () =>
  axios
    .get("/api/users/authorities")
    .then(({ data }) => data)
    .catch(errorHandler);

const addAuthorities = axios => (userId, authorities) =>
  axios
    .post("/api/users/authorities", { id: userId, authorities })
    .then(({ data }) => data)
    .catch(errorHandler);

const setRolePermission = axios => (roleId, permissions) =>
  axios
    .post(
      `${URL}/role/permissions?${querystring.stringify({ roleId })}`,
      permissions,
    )
    .then(({ data }) => data)
    .catch(errorHandler);

const addUserRole = axios => (userId, roleId) =>
  axios
    .post(`${URL}/user/roles/add`, querystring.stringify({ userId, roleId }))
    .then(({ data }) => data)
    .catch(errorHandler);

const removeUserRole = axios => (userId, roleId) =>
  axios
    .post(`${URL}/user/roles/remove`, querystring.stringify({ userId, roleId }))
    .then(({ data }) => data)
    .catch(errorHandler);

const getTpsEndpoints = axios => (page, size, filter = "", sort = "") =>
  axios
    .get(
      `/tps/api/rest-endpoint-permissions?${querystring.stringify({
        page,
        size,
        filter,
        sort: UserSortAdapter(sort),
      })}`,
    )
    .then(({ data }) => data)
    .catch(errorHandler);

const getAuthEndpoints = axios => (page, size, filter = "", sort = "") =>
  axios
    .get(
      `/authservice/api/rest-endpoint-permissions?${querystring.stringify({
        page,
        size,
        filter,
        sort: UserSortAdapter(sort),
      })}`,
    )
    .then(({ data }) => data)
    .catch(errorHandler);

export default {
  createPermission: createPermission(axiosInstance),
  removePermission: removePermission(axiosInstance),
  getPermissions: getPermissions(axiosInstance),

  createRole: createRole(axiosInstance),
  removeRole: removeRole(axiosInstance),
  getRoles: getRoles(axiosInstance),
  getAllRoles: getAllRoles(axiosInstance),
  getAuthorities: getAuthorities(axiosInstance),
  addAuthorities: addAuthorities(axiosInstance),

  setRolePermission: setRolePermission(axiosInstance),
  addUserRole: addUserRole(axiosInstance),
  removeUserRole: removeUserRole(axiosInstance),

  getTpsEndpoints: getTpsEndpoints(axiosInstance),
  getAuthEndpoints: getAuthEndpoints(axiosInstance),
};
